import React from "react";
import { TITLES } from "../data/rssbData";

export const TitlePicker = ({ value, onChange, testid }) => (
  <div data-testid={testid} className="flex gap-1.5">
    {TITLES.map((t, i) => (
      <button
        type="button"
        key={t}
        data-testid={`${testid}-${i}`}
        onClick={() => onChange(t)}
        className={`px-3 py-1 rounded-md text-sm font-dev border transition-colors ${
          value === t
            ? "bg-[#6e1b1b] text-[#f3ead6] border-[#431010]"
            : "bg-[#f6eeda] text-[#5a2a24] border-[#e3d6b6] hover:border-[#6e1b1b]/50"
        }`}
      >
        {t}
      </button>
    ))}
  </div>
);
